import React, { PropsWithChildren } from "react";
import Footer from "components/Footer";
import Head from "components/Head";
import Navbar from "components/Navbar";
import { RuntimeLoader } from "@rive-app/react-canvas";
import "bootstrap/dist/css/bootstrap.min.css";
import "styles/theme.css";
import "styles/custom.css";

interface LayoutProps {
    /**
     * The path for this current page.
     *
     * This does not contain the domain name (you can use the useSiteMetadata
     * hook to get the domain name), but otherwise this is the full path for the
     * page currently being rendered.
     *
     * Can be missing (e.g when rendering the 404 page).
     */
    path?: string;
    /**
     * If present, this is used as the canonical URL for the page. Otherwise a
     * canonical URL is auto-generated using the path and the domain from the
     * site's metadata.
     */
    canonicalURL?: string;
    /** The title of this page */
    title?: string;
    /** An optional description of this page */
    description?: string;
    /** If true, show any temporary sitewide banners on this page */
    shouldShowBanner?: boolean;
    shouldShowDownloads?: boolean;
    isPageAuth?: boolean;
    isPagePhotosIndex?: boolean;
    /** Image to be shown on URL unfurling */
    image?: { path: string };
    slug?: string;
    localised?: boolean;
    language?: string;
    footerHeading?: string;
    footerSubheading?: string;
    /** FAQ data for FAQPage schema markup */
    faqSchema?: Array<{question: string; answer: string}>;
    /** Breadcrumb data for BreadcrumbList schema markup */
    breadcrumbSchema?: Array<{name: string; url: string}>;
}

RuntimeLoader.setWasmUrl("/assets/rive/rive.wasm");

const Layout: React.FC<PropsWithChildren<LayoutProps>> = (props) => {
    return (
        <>
            <Head {...props} />
            <Navbar {...props} />
            <main className="mt-[80px] lg:mt-[160px]">{props.children}</main>
            <Footer {...props} />
        </>
    );
};

export default Layout;
